
export const theme = {
    primary: 'hsl(49, 100%, 50%)',
    honey: 'hsl(41, 90%, 62%)',
    price: 'hsl(41, 85%, 55%)',
    grey: 'hsl(0, 2.9%, 93.1%)',
    darkgrey: 'hsl(0, 2.9%, 70.1%)',
    black: 'hsl(0, 100%, 0%)',
    white: 'hsl(0, 0%, 100%)',
    orange: "hsl(39, 96%, 65%)",
    darkOrange: "hsl(14, 64%, 54%)",
    brown: "hsl(355,13%,20%)",
    borderBlack: "#e0e0e0",
    font: {
        size:{
            xxs: '1.3rem',
            xs: '1.6rem',
            s: '1.9rem',
            xxm: '2.1rem',
            xm: '2.3rem',
            m: '2.6rem',
            mx: '3.0rem',
            l: '3.4rem',
            xl: '3.8rem',
            xxl: '5.0rem',
            xxxl: '7.0rem',
        },
        family:{
            Lobster: '"Lobster", sans-serif',
            Open: '"Open+Sans", sans-serif',
            Montserrat: '"Montserrat", sans-serif',
        }
    },
    media:{
        reset: '@media (min-width: 1px)',
        phone: '@media (min-width: 350px)',
        tablet: '@media (min-width: 750px)',
        desktop: '@media (min-width: 1024px)',
        large: '@media (min-width: 1545px)'

    }
}
